import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CentroCostosTable } from "./CentroCostosTable";
import {
  centroCostoClearActive,
  centroCostosStartLoad,
} from "../../../actions/empresa";
import { NewBtn, PageHeaderUi, ReLoadBtn } from "../../ui";
import { CentroCostoModal } from "./modal/CentroCostoModal";

export const CentroCostosList = () => {
  const dispatch = useDispatch();
  const [visibleModal, setVisibleModal] = useState(false);
  const { centroscostos, loading } = useSelector((state) => state.centrocosto);
  const handleOpenModal = () => setVisibleModal(true);
  const handleCloseModal = () => {
    dispatch(centroCostoClearActive());
    setVisibleModal(false);
  };
  const handleReLoad = () => {
    dispatch(centroCostosStartLoad());
  };
  useEffect(() => {
    dispatch(centroCostosStartLoad());
  }, []);
  return (
    <PageHeaderUi
      title="Centros de Costos"
      subTitle="Listado"
      extra={[
        <ReLoadBtn key="reload" onClick={handleReLoad} />,
        <NewBtn key="nuevo" onClick={handleOpenModal} />,
      ]}
    >
      <CentroCostosTable
        data={centroscostos}
        loading={loading}
        onOpenModal={handleOpenModal}
      />
      <CentroCostoModal openModal={visibleModal} onClose={handleCloseModal} />
    </PageHeaderUi>
  );
};

export default CentroCostosList;
